import { Product } from './ecommerceProduct';
import { GoogleAds } from './ecommerceGoogleAds';

export class EcommerceObject {
    event: string;
    debug: string;
    customerNew: string;
    userId: string;
    customerProvince: string;
    customerCountry: string;
    customerSource: string;
    сustomerType: string;
    dealerName: string;
    isTrial: string;
    transactionType: string;
    paymentType: string;
    googleAds: GoogleAds;
    ecommerce: {
        currencyCode: string,
        purchase: {
            actionField: {
                id: string,
                revenue: number,
                coupon: string
            },
            products: Array<Product>
        }
    };
    eventCallback: () => void;
}



// WEBPACK FOOTER //
// ./src/app/shared/ecommerce/models/ecommerceObject.ts